import React, { useContext, useState } from 'react';
import { BetaContext } from '../context/BetaContext';
import FeedbackModal from './FeedbackModal';
import './BetaBanner.css';

const BetaBanner = () => {
  const { flags } = useContext(BetaContext);
  const [open, setOpen] = useState(false);

  if (!flags?.betaMode) {
    return null;
  }

  return (
    <>
      <div className="beta-banner">
        <div className="beta-banner__content">
          <span className="beta-badge">BETA</span>
          <span>Thanks for testing RS Education Beta.</span>
        </div>
        <button className="beta-banner__button" onClick={() => setOpen(true)}>
          Send Feedback
        </button>
      </div>
      {open && <FeedbackModal onClose={() => setOpen(false)} />}
    </>
  );
};

export default BetaBanner;
